import React, { useState, useEffect, useRef } from "react";

import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    makeStyles,
    Paper,
    Slide,
    Snackbar,
    Typography,
} from "@material-ui/core";

import { uri } from "../../../../help/Api";
import TotalCard from "../../../../components/TotalCard";
import { useHistory } from "react-router-dom";
import {
    useStylesBA,
    useStylesCAB,
    useStylesContainers,
    useStylesHed,
    useStylesSN,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../St/comps/UseStyle";
import { stElemnt } from "../../../../St/comps/cStyle";

import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";

import clsx from "clsx";

import i18next from "i18next";

import moment from "moment";
import axios from "axios";
import { insh, sto } from "../../../../Context/InshData";

import toast, { Toaster } from "react-hot-toast";

import { useRptAF } from "../../../../St/Reviews/UseStyle";
import { reFormatDate } from "../../../../utils/utils";
import { dfaultfilters } from "../../../../services/taswya-servece";
import SarfTwreedTable from "./SarfTwreedTable";
import SarfTwreedForm from "./SarfTwreedForm";
import SarfTwreedHead from "./SarfTwreedHead";
import SarfTwreedAppbar from "./SarfTwreedAppbar";
import SarfTwreedSearch from "./SarfTwreedSearch/SarfTwreedSearch";
import { Alert } from "@material-ui/lab";
import { GetItemFromOptions } from "../../../../services/global-services";
import { handleInputSearchItems, viewItemsHandle } from "../../../Invs/BackEnd/components/SearchItemsFunction";
import { handleSearchAccount, viewHandleAccounts } from "../../../../components/controls/AccountsSearchFinctions";

export const useStylesSafes = makeStyles((theme) => ({
    root: {
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function SarfTwreed(props) {
    const { AutoOptions, IsSarf } = props;
    const { t } = useTranslation(["forms", "translation"]);
    // const [useServerSearch, setUseServerSearch] = useState(countItem);
    const searchTimeout = useRef(null);


    const typeTwreed = [
        { id: 0, name: t("purchase-price") },
        { id: 1, name: t("sale-price") },
    ];
    const [SafesOptions, setSafesOptions] = useState(() => {
        return [{ id: -1, name: t("all") }, ...AutoOptions.Safes];
    });

    const SafesEmp = AutoOptions?.SafeEmp ? AutoOptions?.SafeEmp : AutoOptions.Safes;
    const optionsSafeUser = SafesEmp.filter((obj) => obj.branch == sto.branchi);
    const optionsSafesAdmins = AutoOptions.Safes.filter((obj) => obj.branch == sto.branchi);
    const [localCashe, setLocalCashe] = useState([]);

    const [optionsSafes, setOptionsSafes] = useState(() => {
        return [...optionsSafeUser];
    });

    const countItem = AutoOptions?.items?.length === 250 || AutoOptions?.items?.length === 400 ? true : false;
    const countAccount = AutoOptions?.Accindex === 200 ? true : false;
    const [accountsOptions, setAccountsOptions] = useState(AutoOptions?.Accindex);
    const [newAccountSearch, setNewAccountSearch] = React.useState([]);
    const [searchAccountText, setSearchAccountText] = useState("");

    const [optionsItemsSearch, setOptionsItemsSearch] = useState(AutoOptions.items);
    const [listItemsDownload, setListItemsDownload] = useState([]);

    const defBranch = GetItemFromOptions(sto.branchi, AutoOptions.Branches);

    const defaultTransvalue = {
        id: '',
        no: AutoOptions.other.lastid,
        date: moment(new Date()).format('YYYY-MM-DD'),
        safe: sto.User_typei == 1 ? optionsSafesAdmins[0].id : optionsSafeUser[0].id,
        center: -1,
        refno: '',
        notes: '',
        Type: IsSarf ? 2 : 1,
        res_id: '',
        is_deleted: '',
        omla: 1,
        acc: IsSarf ? AutoOptions.MedAccount[0]?.id : AutoOptions.MedAccount[1]?.id,
        acc2: IsSarf ? AutoOptions.MedAccount[1].id : AutoOptions.MedAccount[0].id,
        branch: sto.branchi,
        Type_Cost: typeTwreed[0].id,
        create_user: '',
        update_user: sto.empi,
        create_date: '',
        update_date: '',
        total_print: '',
        total_update: '',
        create_computer: '',
        update_computer: '',
    };
    const transsubvalue = {
        proc_id: '',
        item: '',
        unit: 1,
        quan: 0,
        totquan: 0,
        price: 0,
        sum: 0,
        sub_branch: sto.branchi,
        sub_center: -1,
        Cost: 0,
        cost_curr: 0,
        qty_balance: 0,
        avg_price: '',
        unitName: '',
        symbol: '',
        barcode: '',
        perc: 1,
        salePrice: 1,
        purchPrice: 1,
        unit_balance: 0,
        avgCost: 0,
        editVal: false,
        editPrice: false,
        editUnits: false,
        no: 0,
        defUnit: {},
        Units: [],
    };
    const defaultvalueAutos = {
        safe: sto.User_typei == 1 ? optionsSafesAdmins[0] : optionsSafeUser[0],
        branch: defBranch,
        center: { id: -1, name: t("all") },
        acc: IsSarf ? AutoOptions.MedAccount[0] : AutoOptions.MedAccount[1],
        acc2: IsSarf ? AutoOptions.MedAccount[1] : AutoOptions.MedAccount[0],
        Type_Cost: typeTwreed[0],
        omla: AutoOptions.Omlat[0],
    };
    const defaultvalueAutosSub = {
        curr: {},
        // curr: AutoOptions.items[0],
        // units: { unit: -1, unitName: "Unit", perc: 1, sale: 0, purch: 0 },
        units: { unit: -1, unitName: t("unit"), perc: 1, sale: 0, purch: 0, curId: 1 },
    };
    const codevalues = {
        id: 0,
        code: '',
    };

    const [rptParams, setRptParams] = React.useState({
        ...defaultTransvalue, no: AutoOptions.other.lastid,
        safe: sto.User_typei == 1 ? optionsSafesAdmins[0].id : optionsSafeUser[0].id,
        branch: sto.branchi,
    });
    const [valueAutos, setValueAutos] = React.useState(defaultvalueAutos);
    const [valueAutosSub, setValueAutosSub] = useState(defaultvalueAutosSub);
    const [unitsOptions, setUnitsOptions] = useState([]);
    const [estelamAfter, setEstelamAfter] = useState(false);

    const [isOpen, setIsOpen] = useState(false);
    const [openSearchMdl, setOpenSearchMdl] = useState(false);

    const onFilterByClick = () => {
        setIsOpen(true);
    };


    const [paramsSubList, setParamsSubList] = useState([]);
    const [dataPrintList, setDataPrintList] = useState([]);

    const [unitsListTable, setUnitsSubListTable] = useState([]);

    const [selectItems, setSelectItems] = useState(true);

    const [rptParamsSub, setRptParamsSub] = useState(transsubvalue);
    const [rptCode, setRptCode] = useState(codevalues);


    const classes = useStylesSafes();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [editing, setEditing] = useState(false);

    const [sum, setSum] = useState(false);

    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const clasCAB = useStylesCAB();

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });
    const [snack, setSnack] = React.useState(insh.Snack);
    const clasSN = useStylesSN();

    const handOSnack = (newState) => {
        setSnack({ openSnak: true, ...newState });
    };
    const { vertical, horizontal, openSnak } = snack;
    const handCSnack = (event, reason) => {
        // if (reason === 'clickaway') { return; }
        setSnack({ ...snack, openSnak: false });
    };
    const frontSnack = () => {
        return (
            <div className={clasSN.rootSN}>
                <Toaster />

                <Snackbar
                    anchorOrigin={{ vertical, horizontal }}
                    open={openSnak}
                    autoHideDuration={snack.time}
                    onClose={handCSnack}
                    key={vertical + horizontal}
                    className={clasSN.snackbarSN}
                >
                    <Alert onClose={handCSnack} severity={snack.severit}>
                        {" "}
                        {snack.text}{" "}
                    </Alert>
                </Snackbar>
            </div>
        );
    };

    const his = useHistory();
    const [filters, setFilters] = useState(dfaultfilters);

    const [uiElement, setUiElement] = useState({});
    const [openButtonsSearch, setOpenButtonsSearch] = useState(false);
    const [procIdSearch, setProcIdSearch] = useState(0);



    function TransitionUp(props) {
        return <Slide {...props} direction="up" />;
    }

    const onChangeBarcodeSearch = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const newItem = localCashe.find((obj) => obj.item.barcode.toString() === rptParamsSub.barcode.toString() &&
            obj.safe.id.toString() === rptParams.safe.toString());
        if (newItem) {
            setUnitsOptions(newItem?.units ?? []);
            barcodeadd({ ...newItem?.item }, { ...newItem?.unit }, newItem?.val ?? 0, newItem?.avrg ?? newItem?.purch);
        } else {
            getBarcodeMulti(rptParamsSub.barcode, rptParams.safe, rptParamsSub.currency);
        }
        // getBarcodeMulti(rptParamsSub.barcode, rptParams.safe, rptParamsSub.currency);
    };

    const getBarcodeMulti = async (barcode, safe) => {

        let item = null;
        let unitF = null;
        let ibance = { Qtys: 0, avgCost: 0 };
        let units = null;
        let avgCost = null;


        if (barcode != null || safe != -1 || safe != null) {
            await axios
                .get(
                    uri +
                    `RptSafes/CurrCodesUnitsSub?currCode=${barcode}
        &&emp=${sto.empi}
        &&safe=${safe}`
                )
                .then((res) => {

                    item = res.data?.barcodes[0];
                    unitF = res.data?.unitsSub[0];
                    units = res.data?.unitsSub;
                    ibance = res.data?.balance[0] ?? { Qtys: 0, avgCost: 0 };
                    setUnitsOptions(res.data?.unitsSub);
                })
                .catch((err) => {
                    // toast.error("No item found for this barcode");
                    console.log(err);
                });
            if (item != null) {
                const newItem = localCashe.find((obj) => obj.item.barcode.toString() === item.barcode.toString() &&
                    obj.safe.id.toString() === rptParams.safe.toString());
                let resv = {
                    valQ: Number(ibance?.Qtys),
                    avg: Number(ibance?.avgCost)
                }
                if (!newItem) {
                    const addNewItem = { item: item, unit: unitF, val: resv?.valQ, avrg: resv?.avg, units: units, safe: valueAutos.safe }
                    setLocalCashe([...localCashe, addNewItem]);
                }
                setSelectItems(false);
                await barcodeadd({ ...item }, { ...unitF }, resv.valQ, resv.avg);
            } else {
                toast.error(t("item-not-found-for-barcode"));
            }
        }

    };



    const barcodeadd = (dataCode, unitF, ibancee, avrgCost) => {

        let percc = dataCode.perc;
        let prc = valueAutos.Type_Cost.id == 1 ? parseFloat(dataCode.sale) : parseFloat(dataCode.purch);
        // let qunntity = 0;
        let qunntity = parseFloat(ibancee);

        let untBlnce = (parseFloat(qunntity) / parseFloat(dataCode.perc)).toFixed(2);
        let difff = 0 - parseFloat(untBlnce);
        setRptParamsSub({
            ...rptParamsSub,
            item: dataCode.curr,
            barcode: dataCode.barcode,
            symbol: dataCode.symbol,
            qty_balance: parseFloat(qunntity),
            perc: dataCode.perc,
            quan: 1,
            totquan: 1,
            price: rptParams.Type_Cost == 1 ? parseFloat(dataCode.sale) : parseFloat(dataCode.purch),
            sum: rptParams.Type_Cost == 1 ? parseFloat(dataCode.sale * 1) : parseFloat(dataCode.purch * 1),
            salePrice: parseFloat(dataCode.sale),
            purchPrice: parseFloat(dataCode.purch),
            cost_curr: parseFloat(dataCode.purch),
            Cost: parseFloat(dataCode.purch),
            total: ((prc * 1)).toFixed(2),
            value: ((parseFloat(dataCode.perc) * 1)).toFixed(2),
            unit: dataCode.unit,
            unitName: dataCode.unitName,
            unit_balance: qunntity,
            sub_branch: rptParams.branch,
            sub_center: rptParams.center,
            avg_price: ibancee == 0 ? parseFloat(dataCode.purch) : parseFloat(avrgCost),
            no: paramsSubList?.length,
        });

        const resItem = { id: dataCode.curr, name: dataCode.symbol, nameE: "", barcode: dataCode.barcode };

        setValueAutosSub({
            curr: resItem,
            units: unitF,
        });
        setUnitsSubListTable([...unitsListTable, unitsOptions]);
        const newSelect = AutoOptions.items.find((obj) => obj.barcode.toString() === dataCode.barcode.toString());
        if (!newSelect) { setListItemsDownload([resItem, ...listItemsDownload]); }
    };
    const selectRow = (row) => {
        setEditing(true);
        setSelectItems(false);
        setRptParamsSub({ ...row });

        let res = { units: {}, curr: {} };
        AutoOptions.items.map((x) => {
            if (x.id == row.item) res.curr = x;
        });

        setValueAutosSub({
            ...defaultvalueAutosSub,
            curr: res.curr,
            units: { unit: row.unit, unitName: row.unitName, perc: 1, sale: row.salePrice, purch: row.cost_curr, curId: row.item },
        })
    };

    const onSubmit = (e) => {
        e.preventDefault();

        let sumquant = 0;
        let sumPric = 0;

        sumquant = (parseFloat(rptParamsSub.perc) * parseFloat(rptParamsSub.quan)).toFixed(2);
        sumPric = (parseFloat(rptParamsSub.quan) * parseFloat(rptParamsSub.price)).toFixed(2);

        setRptParamsSub({
            ...rptParamsSub, sum: sumPric, totquan: sumquant,
            no: paramsSubList.length,
            Units: unitsOptions, defUnit: valueAutosSub.units,
        });
        let newData = {
            ...rptParamsSub, sum: sumPric, totquan: sumquant,
            no: paramsSubList.length,
            Units: unitsOptions, defUnit: valueAutosSub.units,
        }
        var oldData1 = paramsSubList.filter((obj) => obj.item == rptParamsSub.item);
        console.log("the oldadata is", oldData1);

        if (rptParamsSub.item === "" || rptParamsSub.item === null) {
            handOSnack({
                vertical: "top",
                horizontal: "center",
                severit: "warning",
                text: t("please-load-item-data"),
                time: 2000,
            });
        } else {

            if (oldData1.length != 0) {
                if (editing) {
                    setEditing(false);
                    setSelectItems(true);
                    const index = newData?.no;
                    const dataUpdate = [...paramsSubList];
                    dataUpdate[index] = { ...newData };
                    setParamsSubList([...dataUpdate]);
                    setRptParamsSub(transsubvalue);
                    setValueAutosSub(defaultvalueAutosSub);
                }
            } else {

                setParamsSubList([...paramsSubList, newData]);
                setSelectItems(true);
                setRptParamsSub(transsubvalue);
                setValueAutosSub(defaultvalueAutosSub);
            }
        }

    };

    const onChangeDataSub = (propName) => (event) => {
        setRptParamsSub({
            ...rptParamsSub, [propName]: event.target.value,
        });
    };

    const onChangeDataSubQ = (propName) => (event) => {

        setRptParamsSub({
            ...rptParamsSub, [propName]: event.target.value,
        });
    };
    const MathChangIdata = (prop, val) => {
        let i = {
            prc: Number(rptParamsSub.price),
            quan: Number(rptParamsSub.quan),
            sal: Number(rptParamsSub.salePrice),
            perc: Number(rptParamsSub.perc),
            prch: Number(rptParamsSub.purchPrice),
            sumPrc: Number(0),
            sumQun: Number(0),

            res: Number(val),
        };

        if (prop === "price") {
            i.sumPrc = i.res * i.quan;
            i.sumQun = i.perc * i.quan;
        }
        else if (prop === "quan") {
            i.sumPrc = i.res * i.prc;
            i.sumQun = i.perc * i.res;

        }
        setRptParamsSub({
            ...rptParamsSub,
            [prop]: i.res,
            sum: i.sumPrc,
            totquan: i.sumQun,
        });

    };
    const onChangeDataSubP = (prop) => (event) => {
        MathChangIdata(prop, event.target.value);
    };

    const onChangeData = (propName) => (event) => {
        setRptParams({
            ...rptParams, [propName]: event.target.value, Type_Cost: valueAutos.Type_Cost.id
        });
    };
    const addnewSearch = (newValue) => {
        const newSelect = AutoOptions?.Accindex.find((obj) => obj.id === newValue.id);
        const newSelect2 = newAccountSearch.find((obj) => obj.id === newValue.id);
        if (!newSelect && !newSelect2) {
            setNewAccountSearch([newValue, ...newAccountSearch]);
            setAccountsOptions([newValue, ...newAccountSearch, ...AutoOptions.Accindex]);
        } else {
            setAccountsOptions([...newAccountSearch, ...AutoOptions.Accindex]);
        }
        setSearchAccountText("");
    };
    const onChangeAutoData = (propName, newValue) => {
        if (propName === "branch") {
            const SafesEmp = AutoOptions?.SafeEmp ? AutoOptions?.SafeEmp : AutoOptions.Safes;
            const optinsSafeBranches = SafesEmp.filter((obj) => obj.branch == newValue.id);
            if (optinsSafeBranches !== null) {
                setValueAutos({ ...valueAutos, [propName]: newValue, safe: optinsSafeBranches[0] });
                setRptParams({ ...rptParams, branch: newValue.id, safe: optinsSafeBranches[0].id });
                setOptionsSafes([...optinsSafeBranches]);
                setRptParamsSub({ ...transsubvalue, sub_branch: newValue.id })
            } else {
                setValueAutos({ ...valueAutos, [propName]: defBranch });
                setRptParams({ ...rptParams, [propName]: defBranch.id });
                setRptParamsSub({ ...transsubvalue, sub_branch: defBranch.id })
            }
        } else if (propName === "acc" || propName === "acc2") {
            setValueAutos({ ...valueAutos, [propName]: newValue });
            setRptParams({ ...rptParams, [propName]: newValue.id });
            addnewSearch(newValue);
        }
        else {
            setValueAutos({ ...valueAutos, [propName]: newValue });
            setRptParams({ ...rptParams, [propName]: newValue.id });
        }
    };
    const onChangeAutoCost = (propName, newValue) => {
        setValueAutos({ ...valueAutos, [propName]: newValue });
        setRptParams({ ...rptParams, Type_Cost: newValue.id });

    };

    const onChangeAutoDataSubunit = (propName, newValue) => {
        setValueAutosSub({ ...valueAutosSub, [propName]: newValue });
        let quantot = 0.0;
        let pricee = 0.0;
        let sumPrc = 0.0;
        let AllQun = 0.0;

        sumPrc = valueAutos.Type_Cost.id == 1 ? parseFloat(newValue.sale) : parseFloat(newValue.purch);
        quantot = (parseFloat(rptParamsSub.quan) * parseFloat(newValue.perc)).toFixed(2);
        sumPrc = (parseFloat(rptParamsSub.quan) * parseFloat(sumPrc)).toFixed(2);
        AllQun = (parseFloat(rptParamsSub.qty_balance) / parseFloat(newValue.perc)).toFixed(2);
        setRptParamsSub({
            ...rptParamsSub,
            unit: newValue.unit,
            perc: newValue.perc,
            price: pricee,
            cost_curr: newValue.purch,
            Cost: newValue.purch,
            sum: sumPrc,
            totquan: quantot,
            purchPrice: newValue.purch,
            salePrice: newValue.sale,
            unitName: newValue.unitName,
            unit_balance: AllQun,
            editVal: false,
            editPrice: false,
            editUnits: false,
        });
    };

    const onChangeAutoDataSubCurr = (propName, newValue) => {
        setSearchText("");
        setValueAutosSub({ ...valueAutosSub, curr: newValue });
        setRptParamsSub({ ...rptParamsSub, item: newValue.id, symbol: newValue.name, barcode: newValue.barcode });

        const newItem = localCashe.find((obj) => obj.item.barcode.toString() === newValue.barcode.toString() &&
            obj.safe.id.toString() === rptParams.safe.toString());
        if (newItem) {
            setUnitsOptions(newItem?.units ?? []);
            barcodeadd({ ...newItem?.item }, { ...newItem?.unit }, newItem?.val ?? 0, newItem?.avrg ?? newItem?.purch);
        } else {
            getBarcodeMulti(newValue.barcode, rptParams.safe, newValue.id);
        }

    };


    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();

    };
    const cls = useRptAF();


    const [prevent, setPrevent] = useState(insh.prevents);
    const [infoData, setInfoData] = useState({ open: false });

    /* s PMD */
    const [openPMD, setOpenPMD] = useState(false);
    const [barcodeDialogOpen, setBarcodeDialogOpen] = useState(false);

    const clasBA = useStylesBA();
    const [transition, setTransition] = React.useState(undefined);

    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });
    const ButtonWitting = (prop) => {
        reloadGets();

    };
    const [searchText, setSearchText] = useState("");

    const handleInputSearch = (event, newValue, reason) => {
        setSearchText(newValue);
        const allOptions = [...AutoOptions.items, ...listItemsDownload];
        handleInputSearchItems(newValue, allOptions, searchTimeout, setOptionsItemsSearch, countItem, true, reason);
    }
    const handleIconSearch = () => {
        if (searchText != "") {
            viewItemsHandle('', searchText, setOptionsItemsSearch);
        }
    };
    const handNewItem = () => {
        reloadGets();
        //const defaultTG = AutoOptions.tax_groups?.filter((t) => t.isDefault == true);
        setLocalCashe([]);
        setOptionsItemsSearch(AutoOptions.items);
        setPrevent(insh.prevents);
        setParamsSubList([]);
        setRptParamsSub(transsubvalue);
        setUnitsOptions([]);
        setSelectItems(false);
        setValueAutosSub(defaultvalueAutosSub);
        setValueAutos(defaultvalueAutos);
        setEstelamAfter(false);
        setOpenButtonsSearch(false);
        setProcIdSearch(0);
    };
    const timer = React.useRef();

    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "print") { printHandle(); }
            else if (prop === "save") { handNewItem(); }
            else if (prop === "delete") { handNewItem(); }
            else {
                handNewItem();
            }
            setPrevent(true);
        }, 2000);
    };
    const printHandle = () => {

        if (paramsSubList == 0) {
            alert(t("no-data"));
        } else {
            const data2 = paramsSubList.map((row, i) => {
                return {
                    ...row,
                    val1: row.quan,
                    value: row.totquan,
                    total: row.sum,
                };
            });
            const info = {
                data: data2,
                tot: {
                    count: paramsSubList.length,
                    totQun: paramsSubList
                        .reduce((a, v) => (a = a + parseFloat(v.quan)), 0)
                        .toFixed(2),
                    totCost: paramsSubList
                        .reduce((a, v) => (a = a + parseFloat(v.totquan)), 0)
                        .toFixed(2),
                    totPrice: paramsSubList
                        .reduce((a, v) => (a = a + parseFloat(v.sum)), 0)
                        .toFixed(2)
                },
                title: IsSarf ? t("sarf-order-title") : t("twreed-order-title"),
                date: rptParams.date,
                transNo: rptParams.no,
                nDate: moment(new Date()).format("YYYY-MM-DD"),
                branch: valueAutos.branch?.name,
                kind: 2,
                showPrice: true,
                safe: valueAutos.safe.name,
            };
            localStorage.setItem("iInfos", JSON.stringify(info));
            his.push({ pathname: "/ReviewTransfer" });
            window.location.reload(false);
        }
    };
    const inputRef = useRef(null);
    const keepFocus = () => {
        inputRef.current.focus();
    };

    const newToI = (timr) => {
        ButtonLoading("new");
        ButtonSuccess("new", 1000);
        keepFocus();
        //handNewItem();
    };
    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });


    const addChangds = () => {
        rptParams.date =
            moment(rptParams.date).format("YYYY-MM-DD") +
            moment(new Date()).format(" h:mm A");

        rptParams.branch = valueAutos.safe.branch;
    }
    const [openDw, setOpenDw] = useState(false);

    const handOpenDw = (Transition) => {
        setTransition(() => Transition);
        setOpenDw(true);
    };
    const handCloseDw = () => {
        setOpenDw(false);
    };
    const onClickButton = async (procId, type) => {
        const tb = {
            ButtonSearchSarfT: true,
            stor: sto,
            parms: {
                tname: type,
                branch: sto.branchi,
                iprocid: procId,
                iempid: sto.empi,
                type: IsSarf ? 2 : 1,
            },
        };
        axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setProcIdSearch(res.data?.sarfT_data?.id);
                if (res.data?.sarfT_data.id > 0) {
                    onRowClick(res.data.sarfT_data);
                }
            })
            .catch((error) => {
            });
    };
    const onRowClick = async (rowData) => {
        setPrevent(false);
        await axios.get(uri + `TwreedSrf/TwreedSarfSubs?twreedSarf_id=${rowData.id}`).then(res => {
            handCloseDw();
            getSearchHeadData({ ...rowData }, res.data);
        }).catch(err => {
            console.log(err);
            toast.error(t("data-fetch-failed"))
        });
        // setSubmitting(false)
    };
    const getSearchHeadData = (sTransferData, subData) => {
        setParamsSubList(
            subData.map((sub, i) => {
                return {
                    ...sub,
                    no: i,
                    item: sub.item,
                    barcode: sub.barcode,
                    symbol: sub.itemName,
                    unit: sub.unit,
                    unitName: sub.unitName,
                    quan: sub.quan,
                    totquan: sub.totquan,
                    price: sub.price,
                    cost_curr: sub.cost_curr,
                    sum: sub.sum,
                    salePrice: sTransferData.Type_Cost == 1 ? sub.price : 0,
                    purchPrice: sTransferData.Type_Cost == 1 ? 0 : sub.price,
                    qty_balance: 0,
                    unit_balance: 0,
                    purchPrice: sub.cost_curr,
                    editVal: false,
                    editPrice: false,
                    editUnits: false,
                    defUnit: {},
                    Units: [],
                    perc: (parseFloat(sub?.totquan) / parseFloat(sub.quan)).toFixed(2),
                };
            }));
        setUnitsSubListTable(
            subData.map((sub) => {
                return {
                    curId: sub.currency,
                    unit: sub.unit,
                    unitName: sub.unitName,
                    sale: sTransferData.Type_Cost == 1 ? sub.price : 0,
                    purch: sTransferData.Type_Cost == 1 ? 0 : sub.price,
                    perc: sub.perc,
                };
            }));
        setRptParams({
            ...rptParams,
            no: sTransferData.no,
            acc: sTransferData.acc,
            acc2: sTransferData.acc2,
            safe: sTransferData.safe,
            center: sTransferData.center,
            no: sTransferData.no,
            id: sTransferData.id,
            refno: sTransferData.refno,
            branch: sTransferData.branch,
            Type_Cost: sTransferData.Type_Cost,
            notes: sTransferData.notes,
            date: reFormatDate(sTransferData.date),
            res_id: sTransferData.res_id,
            //Type:sTransferData.Type,
        });

        let res = { acc: {}, acc2: {}, safe: {}, centers: {}, typesCost: {}, omla: {}, branch: {} };
        let acc1 = {};
        let acc2 = {};
        AutoOptions.Safes.map((x) => {
            if (x.id == sTransferData.safe) res.safe = x;
        });
        var res_acc1 = AutoOptions.Accindex.find((obj) => obj.id === sTransferData.acc);
        if (res_acc1) { acc1 = res_acc1; }
        else {
            const acc_no1 = sTransferData.acc;
            viewHandleAccounts(searchAccountText, setAccountsOptions, acc_no1, acc1, AutoOptions.Accindex);
        }
        AutoOptions.Accindex.map((x) => {
            if (x.id == sTransferData.acc) { res.acc = x; }
        });
        var res_acc2 = AutoOptions.Accindex.find((obj) => obj.id === sTransferData.acc2);
        if (res_acc2) { acc2 = res_acc2; }
        else {
            const acc_no2 = sTransferData.acc2;
            viewHandleAccounts(searchAccountText, setAccountsOptions, acc_no2, acc2, AutoOptions.Accindex);
        }
        // AutoOptions.Accindex.map((x) => {
        //     if (x.id == sTransferData.acc2) res.acc2 = x;
        // });
        typeTwreed.map((x) => {
            if (x.id == sTransferData.Type_Cost) res.typesCost = x;
        });
        AutoOptions.center.map((x) => {
            if (x.id == sTransferData.center) res.centers = x;
        });
        AutoOptions.Omlat.map((x) => {
            if (x.id == sTransferData.omla) res.omla = x;
        });
        AutoOptions.Branches.map((x) => {
            if (x.id == sTransferData.branch) res.branch = x;
        });

        setValueAutos({
            ...valueAutos,
            safe: res.safe,
            // acc: res.acc,
            // acc2: res.acc2,
            acc: acc1,
            acc2: acc2,
            center: res.centers,
            Type_Cost: res.typesCost,
            omla: res.omla,
            branch: res.branch,
        })
    };

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });

    const addToBS = (props) => {
        if (paramsSubList.length > 0 && rptParams.safe !== "" && rptParams.safe !== null) {
            if (rptParams.acc !== "" && rptParams.acc !== null && rptParams.acc !== -1) {
                addChangds();
                ButtonLoading("save");
                let transSub = paramsSubList?.map(x => {
                    console.log("thre group is ", x);
                    return {
                        proc_id: rptParams.id,
                        item: x?.item,
                        unit: x?.unit,
                        price: x?.price,
                        quan: x?.quan,
                        totquan: x?.totquan,
                        sum: x?.sum,
                        sub_branch: rptParams.branch,
                        sub_center: x?.sub_center,
                        cost_curr: x?.cost_curr,
                        Cost: x?.Cost,
                        qty_balance: x?.qty_balance,
                    }
                })
                const model = {
                    twreed: rptParams,
                    _Data: transSub,
                };
                console.log("the curre data is ", model);

                prevent
                    ? axios
                        .post(uri + "TwreedSF", model)
                        .then((res) => {
                            setLocalCashe([]);
                            if (res.data?.data != null) {
                                // alert("Barcode already exists");
                                setUnitsSubListTable([]);
                                setParamsSubList([]);
                                setUnitsOptions([]);
                                ButtonSuccess(props, 1000);
                                toast.success(t("save-success"));
                            } else {
                                setUnitsSubListTable([]);
                                setParamsSubList([]);
                                setUnitsOptions([]);
                                ButtonSuccess(props, 1000);
                                toast.success(t("save-success"));

                            }
                            keepFocus();
                        })
                        .catch((res) => {
                            if (res.response?.data?.Message != null) {
                                toast.error(res.response?.data?.Message);
                            } else
                                ButtonSuccess(props, 1000);
                            toast.error(t("save-failed"));

                        })

                    :
                    axios
                        .put(uri + "TwreedSF", model)
                        .then((res) => {
                            setLocalCashe([]);
                            if (res.data?.data != null) {
                                setUnitsSubListTable([]);
                                setParamsSubList([]);
                                setUnitsOptions([]);
                                ButtonSuccess(props, 1000);
                                toast.success(t("update-success"));
                            } else {
                                setUnitsSubListTable([]);
                                setParamsSubList([]);
                                setUnitsOptions([]);
                                ButtonSuccess(props, 1000);
                                toast.success(t("update-success"));

                            }
                            keepFocus();
                        })
                        .catch((res) => {
                            if (res.response?.data?.Message != null) {
                                toast.error(res.response?.data?.Message);
                            } else
                                ButtonSuccess(props, 1000);
                            toast.error(t("update-failed"));
                        });
            } else {
                alert(t("please-select-account"));

            }
        } else {
            alert(t("complete-data"));
        }
    };

    const deleteToI = async (e) => {


        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");

        await axios.delete(uri + `TwreedSF?id=${rptParams.id}`).then(res => {
            toast.success(t("delete-success"));
            setLocalCashe([]);
            ButtonSuccess("delete", 1000);

        }).catch(err => {
            if (err.response?.data?.Message != null) {
                toast.error(err.response?.data?.Message);
            } else
                console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error("not delete ")
        })
    };
    const reloadGets = async () => {
        const tb = {
            wait: true,
            other: true,
            // Items: true,
            parms: {
                iempid: sto.empi,
                tname: IsSarf ? "sarf" : "twreed",
                branch: sto.branchi
                // takei: 1,
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setRptParams({
                    ...defaultTransvalue,
                    no: res.data.other.lastid,
                    branch: AutoOptions.Branches[0].id,
                    safe: AutoOptions.Safes[0].id,
                });
            })
            .catch((error) => {
            });
    };


    const isMobileDevice = () => {
        return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    };


    const handleInputSearchAccount = (event, newValue, reason) => {
        const allOptions = [...newAccountSearch, ...AutoOptions.Accindex];
        handleSearchAccount(newValue, allOptions, searchTimeout, setAccountsOptions,
            countAccount, setSearchAccountText, reason);
    };
    const handleIconSearchAccount = () => {
        if (!countAccount && searchAccountText != "") {
            viewHandleAccounts(searchAccountText, setAccountsOptions, -1);
        }
    };
    useEffect(() => {
        if (isMobileDevice()) return;

        const handleKeyDown = async (event) => {
            //  if (event.altKey && event.key ==="p"){
            if (event.key === 'F3') {
                event.preventDefault();
                if (paramsSubList.length > 0 && rptParams.safe !== "" && rptParams.safe !== null) {
                    if (rptParams.acc !== "" && rptParams.acc !== null && rptParams.acc !== -1) {
                        await addToBS("save");
                    } else {
                        alert(t("please-select-account"));
                    }
                } else {
                    alert(t("complete-data"));
                }

            }
            if (event.key === 'F10') {
                event.preventDefault();
                if (paramsSubList.length > 0 && rptParams.safe !== "" && rptParams.safe !== null) {
                    if (rptParams.acc !== "" && rptParams.acc !== null && rptParams.acc !== -1) {
                        await addToBS("print");
                    } else {
                        alert(t("please-select-account"));
                    }
                } else {
                    alert(t("complete-data"));
                }

            }
            if (event.key === 'F2') {
                event.preventDefault();
                await newToI(1000);
            }
            if (event.key === 'F7') {
                event.preventDefault();
                if (estelamAfter) {
                    await printHandle();
                }
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };

    }, [paramsSubList, rptParams, prevent, confirmDialog, estelamAfter]);



    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    color="primary"
                >
                    {IsSarf ? t("sarf-order-title") : t("twreed-order-title")}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: colors.blue[50],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >
                    {/* <SafesTransferFilter {...{ valueAutos, setValueAutos }} /> */}

                    <SarfTwreedHead
                        {...{
                            AutoOptions,
                            rptParams,
                            onChangeData,
                            onChangeAutoData,
                            typeTwreed,
                            onChangeAutoCost,
                            valueAutos,
                            IsSarf,
                            SafesEmp,
                            optionsSafes,
                            prevent,
                            setInfoData,
                            infoData,
                            accountsOptions,
                            handleIconSearchAccount,
                            handleInputSearchAccount,
                            searchAccountText
                        }}
                    />
                    <Grid
                        container
                        justifyContent="center"
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        spacing={1}
                    >

                    </Grid>
                </Container>
                {/* <br /> */}
                <Container maxWidth={false} style={{ paddingLeft: "10px", paddingRight: "10px", paddingTop: "15px" }}
                >
                    <Grid
                        container
                        justifyContent="center"
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        spacing={1}>
                        <SarfTwreedForm
                            {...{
                                AutoOptions,
                                rptParamsSub,
                                onChangeDataSub,
                                onChangeAutoDataSubunit,
                                valueAutosSub,
                                selectItems,
                                unitsOptions,
                                onChangeBarcodeSearch,
                                onChangeAutoDataSubCurr,
                                onSubmit,
                                onChangeDataSubQ,
                                onChangeDataSubP,
                                editing,
                                inputRef,
                                handleInputSearch,
                                optionsItemsSearch,
                                searchText,
                                handleIconSearch
                            }}
                        />

                    </Grid>
                </Container>
                {/* <br /> */}
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                    }}
                >
                    <Grid container justifyContent="center">
                        <Grid item container justifyContent="center" xs={12}>
                            <BeatLoader loading={fetching} color={colors.blue[50]} />
                            {!fetching && (
                                <SarfTwreedTable
                                    {...{
                                        paramsSubList,
                                        rptParams,
                                        valueAutosSub,
                                        setValueAutosSub,
                                        unitsOptions,
                                        setParamsSubList,
                                        estelamAfter,
                                        selectRow,
                                    }}
                                />
                            )}
                        </Grid>
                        {paramsSubList.length > 0 && (
                            <Grid
                                container
                                lg={12}
                                md={12}
                                className={cls.rootBdydown}
                                style={{
                                    paddingBottom: 5, marginTop: "1rem",
                                    backgroundColor: colors.blue[50], fontFamily: "Amiri-Regular"
                                }}
                            >
                                <Grid container xs={12} /*className={cls.rootchip}*/ style={{
                                    paddingBottom: 5,
                                    backgroundColor: colors.blue[50], fontFamily: "Amiri-Regular",
                                    border: "solid 1px",
                                    padding: "0.3rem 0.1rem 0.3rem 0.1rem",
                                    borderRadius: "0px 0px 5px 0px",
                                }}>

                                    <Grid item xs={2} className={[cls.chipVMU]}>
                                        {t("items-count")}
                                    </Grid>
                                    <Grid item xs={2} className={[cls.chipVMU]}>
                                        {paramsSubList.length}
                                    </Grid>
                                    <Grid item xs={2} className={[cls.chipVMU]}>
                                        {t("total-quantity")}
                                    </Grid>
                                    <Grid item xs={2} className={[cls.chipVMU]}>
                                        {paramsSubList
                                            .reduce((a, v) => (a = a + parseFloat(v.quan)), 0)
                                            .toFixed(2)}
                                    </Grid>
                                    <Grid item xs={2} className={[cls.chipVMU]}>
                                        {t("total-amount")}
                                    </Grid>
                                    <Grid item xs={2} className={[cls.chipVMU]}>
                                        {paramsSubList
                                            .reduce((a, v) => (a = a + parseFloat(v?.sum)), 0)
                                            .toFixed(2)}
                                    </Grid>
                                </Grid>

                            </Grid>)}
                    </Grid>

                </Container>
            </Typography>

            <SarfTwreedAppbar  {...{
                rptParams,
                setBarcodeDialogOpen,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                stElemnt,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                handOpenDw,
                TransitionUp,
                addToBS,
                setOpenDw,
                estelamAfter,
                deleteToI,
                printHandle,
                prevent,
                onClickButton,
                openButtonsSearch,
                setOpenButtonsSearch,
                procIdSearch
            }} />
            <SarfTwreedSearch {...{
                handOpenDw,
                TransitionUp,
                setPrevent,
                openDw,
                transition,
                handCloseDw,
                getSearchHeadData,
                setEstelamAfter,
                SafesOptions,
                IsSarf,
                SafesEmp,
                AutoOptions,
            }}
            />

            {frontSnack()}
        </div>
    );
}
